import { NavLink } from "react-router-dom";

/**
 * Everything of yours in one place: an overview, your saved strategies, every
 * backtest you saved and your paper bots. One entry in the navigation, four tabs
 * here. (Public bots are under Explore.)
 */
export const MY_SPACE_PATHS = ["/me", "/strategies", "/history", "/bots"] as const;

const TABS = [
  { to: "/me", label: "Overview", end: true },
  { to: "/strategies", label: "Strategies", end: false },
  { to: "/history", label: "Backtests", end: false },
  { to: "/bots", label: "Bots", end: false },
] as const;

export function MySpaceTabs() {
  return (
    <nav className="subnav" aria-label="Dashboard">
      {TABS.map((t) => (
        <NavLink
          key={t.to}
          to={t.to}
          end={t.end}
          className={({ isActive }) => `subnav__link${isActive ? " active" : ""}`}
        >
          {t.label}
        </NavLink>
      ))}
    </nav>
  );
}
